if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-sticky-add]');
        this.sentinel = document.querySelector('.product-form__buttons');

        // Prefer the real add-to-cart form: the installment/Shop Pay form
        // also lives inside product-info and matches action*="/cart/add"
        // first, but it has no submit button, which made the sticky button
        // dead. Re-query on every click: Dawn swaps the form node on variant
        // change, so a cached reference goes stale.
        this.getMainForm = () =>
          document.querySelector(
            'product-info form[data-type="add-to-cart-form"][action*="/cart/add"]'
          );

        if (!this.button || !this.sentinel || !this.getMainForm()) return;

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
              this.classList.toggle('is-visible', scrolledPast);
            });
          },
          { threshold: 0 }
        );
        this.observer.observe(this.sentinel);

        // Offset the floating buttons (WhatsApp, locale prompt) clear of this
        // bar. Without this they sit on top of the Add to cart button and
        // swallow the click, which is what the client reported.
        this.syncOffset = () => {
          const visible = this.classList.contains('is-visible');
          document.documentElement.classList.toggle('has-sticky-atc', visible);
          // Publish the bar height so the floating WhatsApp / locale buttons
          // can sit above it instead of over the Add to cart button.
          const height = visible ? Math.round(this.getBoundingClientRect().height) : 0;
          document.documentElement.style.setProperty('--volan-sticky-atc-height', `${height}px`);
        };
        window.addEventListener('resize', this.syncOffset);
        this.syncOffset();
        this.toggleObserver = new MutationObserver(this.syncOffset);
        this.toggleObserver.observe(this, { attributes: true, attributeFilter: ['class'] });

        this.button.addEventListener('click', (event) => {
          event.preventDefault();

          const form = this.getMainForm();
          if (!form) return;

          const add =
            form.querySelector('[name="add"]') || form.querySelector('button[type="submit"]');
          if (!add) return;

          // requestSubmit runs the real submit path, including validation and
          // Dawn's submit handlers. A synthetic click on a detached or
          // re-rendered button can silently do nothing.
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit(add);
          } else if (typeof add.click === 'function') {
            add.click();
          }
        });
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.toggleObserver) this.toggleObserver.disconnect();
        document.documentElement.classList.remove('has-sticky-atc');
      }
    }
  );
}
